<template>
  <v-app id="app">
    <!-- 导航栏 -->
    <TopNavBar></TopNavBar>
    <!-- 侧边导航栏 -->
    <SideNavBar></SideNavBar>
    <!-- 内容 -->
    <v-content>
      <router-view :key="$route.fullPath" />
    </v-content>
    <!-- 页脚 -->
    <Footer></Footer>
    <!-- 返回顶部 -->
    <BackTop></BackTop>
    <!-- 搜索模态框 -->
    <searchModel></searchModel>
    <!-- 登录模态框 -->
    <LoginModel></LoginModel>
    <!-- 注册模态框 -->
    <RegisterModel></RegisterModel>
    <!-- 忘记密码模态框 -->
    <ForgetModel></ForgetModel>
    <!-- 绑定邮箱模态框 -->
    <EmailModel></EmailModel>
    <!-- 音乐播放器 -->
    <!-- <Player v-if="blogInfo.webSite.isMusicPlayer === 1 && !isMobile" /> -->
    <!-- 聊天室 -->
    <!-- <ChatRoom v-if="0 == 1"></ChatRoom> -->
    <FeedBack/>
  </v-app>
</template>

<script>
import TopNavBar from "./components/layout/TopNavBar";
import SideNavBar from "./components/layout/SideNavBar";
import Footer from "./components/layout/Footer";
import BackTop from "./components/BackTop";
import searchModel from "./components/model/SearchModel";
import LoginModel from "./components/model/LoginModel";
import RegisterModel from "./components/model/RegisterModel";
import ForgetModel from "./components/model/ForgetModel";
import EmailModel from "./components/model/EmailModel";
import Player from "./components/zw-player/player.vue";
//import ChatRoom from "./components/ChatRoom";
import FeedBack from "./components/FeedBack";
import { getWebSiteInfo,report} from './api'
export default {
  mounted() {
      this.getBlogInfo()
      // 上传访客信息
      report();
      // 全局图片放大：带 data-zoom 的图单开，
      // 放在 data-zoom-group 容器里的图算一组，可以左右翻
      document.addEventListener("click", this.onZoomClick, true);
  },
  beforeDestroy() {
      document.removeEventListener("click", this.onZoomClick, true);
  },
  components: {
    TopNavBar,
    Player,
    SideNavBar,
    Footer,
    BackTop,
    searchModel,
    LoginModel,
    RegisterModel,
    ForgetModel,
    EmailModel,
    FeedBack
  },
  methods: {
    onZoomClick(e) {
      const img = e.target;
      if (!img || img.tagName !== "IMG") return;
      let group = null;
      for (let n = img.parentElement; n; n = n.parentElement) {
        if (n.hasAttribute && n.hasAttribute("data-zoom-group")) {
          group = n;
          break;
        }
      }
      if (!group && !img.hasAttribute("data-zoom")) return;
      // 图可能被 a 标签包着，别让它跳走
      e.preventDefault();
      e.stopPropagation();
      const nodes = group
        ? Array.prototype.slice.call(group.querySelectorAll("img"))
        : [img];
      const images = nodes.map(n => n.currentSrc || n.src);
      const index = images.indexOf(img.currentSrc || img.src);
      this.$imagePreview({
        images: images,
        index: index < 0 ? 0 : index
      });
    },
    getBlogInfo() {
      getWebSiteInfo().then(res => {
        this.$store.commit("checkBlogInfo", res.data);
      });
    },
  },
  computed: {
    blogInfo() {
      return this.$store.state.blogInfo;
    },
    isMobile() {
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>
